// Composer buttons (emoji, send) tapped while the keyboard is open. On iOS the tap
// first blurs the field → keyboard hides → the WebView is resized (Keyboard
// resize=native) → the button moves under the finger → the click is lost and a
// 2nd tap was needed. Running the action on touchend and cancelling the synthetic
// mouse/click sequence keeps the field focused (keyboard stays up, like WhatsApp)
// and fires on the FIRST tap. Desktop keeps the plain click path.
//
// WKWebView (iPhone/iPad) caveats this must survive:
//  • a cancelled `pointerdown` ALSO swallows WebKit's synthetic click, so the click
//    fallback never came — never cancel pointerdown for touch pointers;
//  • `touchend` may arrive non-cancelable (asynchronous dispatch) → the action then
//    runs from the click that follows, exactly once (dedupe window);
//  • cancelling the synthetic `mousedown` is what keeps the field focused on the
//    click path (desktop mouse included) without killing the click itself.
const MOVE_TOLERANCE = 12;
const DEDUPE_MS = 500;

const firedRecently = (el) => Date.now() - (+el.dataset.tapFiredAt || 0) < DEDUPE_MS;

export const keepFocusTap = (action, { withClick = true } = {}) => {
  const fire = (e) => {
    e.currentTarget.dataset.tapFiredAt = String(Date.now());
    action(e);
  };
  return {
    onMouseDown: (e) => e.preventDefault(),
    onPointerDown: (e) => { if (e.pointerType && e.pointerType !== "touch") e.preventDefault(); },
    onTouchStart: (e) => {
      const t = e.touches[0];
      e.currentTarget.dataset.tapX = t.clientX;
      e.currentTarget.dataset.tapY = t.clientY;
    },
    onTouchEnd: (e) => {
      const el = e.currentTarget;
      const t = e.changedTouches[0];
      if (!t || el.disabled) return;
      const moved = Math.hypot(t.clientX - (+el.dataset.tapX || t.clientX), t.clientY - (+el.dataset.tapY || t.clientY));
      if (moved > MOVE_TOLERANCE) return;
      if (!e.cancelable) return; // click follows → handled by onClick
      e.preventDefault();
      fire(e);
    },
    onClick: (e) => {
      if (firedRecently(e.currentTarget)) { e.preventDefault(); return; }
      if (withClick) fire(e);
    },
  };
};

export default keepFocusTap;
